import React, { useEffect, useState } from 'react';
import prebootLines from './preboot';

const PreBoot = ({ onComplete }) => {
    const [visibleCount, setVisibleCount] = useState(0);

    useEffect(() => {
        if (visibleCount >= prebootLines.length) {
            onComplete?.();
            return;
        }

        const t = setTimeout(() => {
            setVisibleCount(c => c + 1);
        }, 1000);

        return () => clearTimeout(t);
    }, [visibleCount, onComplete]);

    return (
        <div style={{ padding: '24px' }}>
            {prebootLines.slice(0, visibleCount).map((line, i) => (
                <div key={i}>[ OK ] {line}</div>
            ))}
        </div>
    );
};

export default PreBoot;
